import api from '../../config/axios.js';

const state = {
    payment: {},
    errorPayment: "",
    successPayment: "",
    summary: {
        "contracted_value": "Carregando...",
        "transcription_value": "Carregando...",
        "analyse_sentiment_value": "Carregando...",
        "total_size": "Carregando...",
        "total_value": "Carregando...",
        "total_price": "Carregando...",
        "next_payment": "Carregando...",
        "quantity_items": "Carregando...",
        "minutes_transcription": "Carregando...",
        "total_value_minutes_transcription": "Carregando...",
        "minutes_analyse_sentiment": "Carregando...",
        "total_value_minutes_analyse_sentiment": "Carregando...",
        "enable_payment": true
    },
    errorSummary: "",
    errorPaymentModeDefault: "",
    paymentModeDefault: [],
    loadingPaymentMode: true,
    errorPaymentHistory: "",
    paymentHistory: [],
    daysExportFiles: 10,
    servicePrice: "1,98",
    gbFree: 5,
}
const getters = {
    getPayment: state => state.payment,
    getErrorPayment: state => state.errorPayment,
    getSuccessPayment: state => state.successPayment,
    getSummary: state => state.summary,
    getErrorSummary: state => state.errorSummary,
    getErrorPaymentModeDefault: state => state.errorPaymentModeDefault,
    getPaymentModeDefault: state => state.paymentModeDefault,
    getLoadingPaymentMode: state => state.loadingPaymentMode,
    getErrorPaymentHistory: state => state.errorPaymentHistory,
    getPaymentHistory: state => state.paymentHistory,
    getDaysExportFiles: state => state.daysExportFiles,
    getServicePrice: state => state.servicePrice,
    getGbFree: state => state.gbFree
}
const actions = {

    // REALIZANDO A CRIAÇÃO DA ASSINATURA DE PAGAMENTO
    async setProcessSubscriptionPayment({ commit }, data) {
        await api.axios.post('/api/checkout/process', data).catch(error => {
            if(error && error.response && error.response.data && error.response.data){
                commit("setErrorPayment", error.response.data);
            }

        }).then(function(response){
            if(response && response.status == 200){
                commit('setSuccessPayment', "pagamento confirmado, o serviço já está disponibilizado !");
                location.reload();
            }
        });
    },
    // ZERANDO MENSAGEM DE ERRO NO PROCESSAMENTO DE PAGAMENTO
    setResetErrorPayment({ commit }){
        commit("setErrorPayment", "");
    },
    // BUSCANDO O DÉBITO DO CLIENTE
    async setSummary({ commit }, data) {
        await api.axios.post('/api/checkout/summary', data).catch(function(){
            
            commit("setErrorSummary", "Erro ao buscar informações de pagamento, por favor tente novamente mais tarde !");

        }).then(function(response){
            if(response.status == 200){
                commit('setSummary', response.data);
            }
        });
    },
    // BUSCANDO A QUANTIDADE DE DIAS QUE OS ARQUIVOS FICARAM NA NUVEM APÓS O CANCELAMENTO DO SERVIÇO
    async setDaysExportFiles({ commit }) {
        await api.axios.get('/api/export/files/finish').catch(function(){
            
            commit("setDaysExportFiles", 10);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setDaysExportFiles', response.data);
            }
        });
    },
    // BUSCANDO O VALOR DO SERVIÇO
    async setServicePrice({ commit }) {
        await api.axios.get('/api/service/price').catch(function(){
            
            commit("setServicePrice", false);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setServicePrice', response.data);
            }
        });
    },
    // BUSCANDO OS GIGAS LIVRES
    async setGbFree({ commit }) {
        await api.axios.get('/api/gb/free').catch(function(){
            
            commit("setGbFree", 5);

        }).then(function(response){
            if(response && response.status == 200){
                commit('setGbFree', response.data);
            }
        });
    },
    // BUSCANDO MODO DE PAGAMENTO PADRÃO DO CLIENTE
    async setPaymentModeDefault({ commit }, data) {
        await api.axios.post('/api/payment/mode', data).catch(function(){
            
            commit("setErrorPaymentModeDefault", "Erro ao buscar forma de pagamento padrão, por favor tente novamente mais tarde !");

        }).then(function(response){
            commit('setLoadingPaymentMode', false);
            if(response && response.status == 200){
                commit('setPaymentModeDefault', response.data);
            }
        });
    },
    // BUSCANDO HISTÓRICO DE PAGAMENTOS DO CLIENTE
    async setPaymentHistory({ commit }, data) {
        await api.axios.post('/api/payment/history', data).catch(function(){
            
            commit("setErrorPaymentHistory", "Erro ao buscar histórico de pagamentos do cliente, por favor tente novamente mais tarde !");

        }).then(function(response){
            if(response && response.status == 200){
                commit('setPaymentHistory', response.data);
            }
        });
    },
}
const mutations = {
    setProcessSubscriptionPayment: function(state, data){
        state.payment = data;
    },
    setErrorPayment: function(state, data){
        state.errorPayment = data;
    },
    setSuccessPayment: function(state, data){
        state.successPayment = data;
    },
    setErrorSummary: function(state, data){
        state.errorSummary = data;
    },
    setSummary: function(state, data){
        state.summary = data;
    },
    setErrorPaymentModeDefault: function(state, data){
        state.errorPaymentModeDefault = data;
    },
    setPaymentModeDefault: function(state, data){
        state.paymentModeDefault = data;
    },
    setLoadingPaymentMode: function(state, data){
        state.loadingPaymentMode = data;
    },
    setErrorPaymentHistory: function(state, data){
        state.errorPaymentHistory = data;
    },
    setPaymentHistory: function(state, data){
        state.paymentHistory = data;
    },
    setDaysExportFiles: function(state, data){
        state.daysExportFiles = data;
    },
    setServicePrice: function(state, data){
        state.servicePrice = data;
    },
    setGbFree: function(state, data){
        state.gbFree = data;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}